function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import { requiredImage } from '../fragments/index.js';
import donationBoxSettings from './donationBoxSettings.js';
var schema = defineObject('donationBoxSection', {
    title: {
        type: 'string',
        title: 'Title',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    subtitle: {
        type: 'string',
        title: 'Subtitle'
    },
    image: _object_spread({
        title: 'Image'
    }, requiredImage.fragment),
    donationBoxSettings: {
        title: 'Donation Box Settings',
        type: 'donationBoxSettings'
    }
}, [
    donationBoxSettings.schema.donationBoxSettings
]);
var validator = z.object({
    _type: z.literal('donationBoxSection'),
    title: z.string().optional(),
    subtitle: z.string().optional(),
    image: requiredImage.validator.optional(),
    donationBoxSettings: donationBoxSettings.validator.optional()
});
schema.donationBoxSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=donationBoxSection.js.map